import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

import store from '@this/store';
import AuthPopup from '@blocks/auth/AuthPopup';
import { getAuthJumpURL } from '@blocks/auth/service';

import { isPC } from '@/utils/browser';

export function createRouter(options) {
  const { routes, ...otherOptions } = options;

  Vue.use(VueRouter);

  const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    routes,
    scrollBehavior: () => ({ y: 0 }),
  });

  NProgress.configure({ showSpinner: false });

  router.beforeEach(async (to, from, next) => {
    // 进度条开始
    NProgress.start();

    const level = to.meta.level || 1;
    const hasUID = store.state.user.uid;
    if (level < 3 && !hasUID) {
      try {
        // 检查授权（必须保证接口不会自动授权 useAuth: false）
        await store.dispatch('user/checkAuth', to);
        next({ ...to, replace: from.meta.level !== 3 });
      } catch (error) {
        if (error?.code === 4300) {
          // 路由分级
          if (level === 1) {
            // 判断pc端
            if (isPC) {
              AuthPopup(window.parent.location.href);
              next(false);

              // 进度条结束
              NProgress.done();
              return;
            }

            // 1级必须授权成功
            const callback = `${window.location.origin}${process.env.VUE_APP_BASE_URL}${to.fullPath}`;
            const jumpURL = getAuthJumpURL(callback);
            window.parent.location.href = jumpURL;

            // 进度条结束
            NProgress.done();
          } else {
            // 2级授权后显示（不管成功失败）
            next();
          }
        } else {
          console.error(error);
        }
      }
    } else {
      // 3级直接显示（不进行授权）
      next();
    }
  });

  router.afterEach(() => {
    // 进度条结束
    NProgress.done();
  });

  return Object.assign(router, otherOptions);
}
